'use client'

import { forwardRef, useState, useRef, useImperativeHandle } from "react";
import Button from "@/components/button/Button";
import Icon from "@/components/icon/Icon";
import PanelHeader from "@/components/panel/PanelHeader";
import PanelTitle from "@/components/panel/PanelTitle";
import PanelBody from "@/components/panel/PanelBody";
import Slideout from "@/components/slideout/Slideout";
import StackedPanel from "@/components/panel/StackedPanel";
import InventoryTile from "../vehicles/InventoryTile";
import Tile from "@/components/tile/Tile";
import Tiles from "@/components/tile/Tiles";
import useEventListener from "@/components/plugins/EventListener";
import { searchInventory } from "@/data/Inventory";

const FavoritesSlideout = forwardRef((props,ref) => {
  
  const slide = useRef()

  const [visible,setVisible] = useState(false)
  const [vins, setVins] = useState(props.site.session?.vehicles?.favorites || [])
  const [inventory,setInventory] = useState([])
  
  useEventListener("show_favorites_slide", event => {
    toggle()
  })

  useEventListener("visitor_favorites", event => {
    if (event.detail?.vehicles?.favorites) {
      setVins(event.detail?.vehicles?.favorites)
      load(event.detail?.vehicles?.favorites)
    }
  })
  
  const toggle = () => {
    setVisible(!visible)
    slide.current.toggle()
    load(vins, true)
  }
  
  const load = (vins, force) => {
    if (vins.length > 0) {
      if (visible || force) {
        searchInventory(props.site, { vin: vins || [] }, null, "list")
        .then(data => {
          setInventory(data.results)
        })
      }
    } else {
      setInventory([])
    }
  }
  
  useImperativeHandle(ref, () => ({
    toggle
  }))
  
  return <Slideout ref={slide}>
      <StackedPanel>
        <PanelHeader>
          <PanelTitle leftPad={true} centered={true}>
            <h2>My Favorites</h2>&nbsp;&nbsp;<span className="text-red"><Icon {...props} name="heart-filled"></Icon></span>
          </PanelTitle>
          <div>
            <Button theme={'icon'} onClick={e => toggle(e)} label={ 'Close' }>
              <Icon {...props} name="x"></Icon>
            </Button>
          </div>
        </PanelHeader>
        <PanelBody padded={true}>
          <section>
            <Tiles column={true}>
              { inventory.length == 0 &&
              <Tile {...props} invisible={true}><></></Tile>
              }
              { inventory.map((item,index) => (
                <InventoryTile key={index} index={index} {...props} item={item} favs={true}></InventoryTile>
              ))}
            </Tiles>
          </section>
        </PanelBody>
      </StackedPanel>
  </Slideout>    
  
})

FavoritesSlideout.displayName = "FavoritesSlideout"
export default FavoritesSlideout